import React, {useState, useEffect} from 'react';
import axios from 'axios';

export default function MakePracticeLabPackage(){
    const [currTest, setCurrTest] = useState('')
    const [testType, setTestType] = useState('')
    const [errMsg, setErrMsg] = useState('')
    const [DigitalSATList, setDigitalSATList] = useState([])
    const [ACTList, setACTList] = useState([])
    const [students, setStudents] = useState([])
    const [searchStudent, setSearchStudent] = useState('')
    const [searchTest, setSearchTest] = useState('')

    useEffect(()=>{
        getSATs();
        getACTs();
    }, [])

    const getSATs = async () => {
        try{
            const response = await axios.get('https://www.tenaflyprepacademy.com/server/allDigitalSAT', {
                headers: {"JWT":("Bearer "+localStorage.getItem('user'))}
            })
            setDigitalSATList(response.data ? response.data : [])
        } catch(err){
            console.log(err)
        }

    }

    const getACTs = async () => {
        try{
            const response = await axios.get('https://www.tenaflyprepacademy.com/server/allACT', {
                headers: {"JWT":("Bearer "+localStorage.getItem('user'))}
            })
            setACTList(response.data ? response.data : [])
        } catch(err){
            console.log(err)
        }
    }

    useEffect(()=>{
        setErrMsg('')
    }, [])

    const getStudents = async (e) => {
        e.preventDefault()
        try{
            const response = await axios.get('https://www.tenaflyprepacademy.com/server/allStudents', {
                headers: {"JWT":("Bearer "+localStorage.getItem('user'))}
            })
            console.log(response)
            console.log(response.data)
            response.data.sort((a,b) => (a.first_name+a.last_name).toString().localeCompare((b.first_name+b.last_name).toString()))
            setStudents(response.data)
            setErrMsg('')
            console.log(response.data)
        } catch(err){
            console.log(err)
            console.log("error")
            setErrMsg('No server response. Please try again later.')
        }
    }

    return(
        <>
            <div>
                <h1>LMFAO</h1>
                {/*  */}
            </div>
        </>
    )
}